// extracted by mini-css-extract-plugin
export default {"container":"styles_container__nDO-5","wrapper":"styles_wrapper__PEGCO"};